import {Injectable, TemplateRef} from '@angular/core';
import {
    CsDropDownTogglerTemplatesComponent
} from "@app/shared/cs-components/cs-drop-down/cs-drop-down-toggler-templates/cs-drop-down-toggler-templates.component";
import {
    CsDropDownItemTemplatesComponent
} from "@app/shared/cs-components/cs-drop-down/cs-drop-down-item-templates/cs-drop-down-item-templates.component";
import {Observable, of} from "rxjs";
import {ICsDropDown} from "@app/shared/cs-components/cs-components.interface";
import {ICsDdGroupItem, ICsDdItem} from "@app/shared/cs-components/cs-drop-down/cs-drop-down.interface";

@Injectable({
    providedIn: 'root'
})
export class CsDropDownService {

    togglerTemplates: {[key: string]: TemplateRef<any>};
    itemTemplates: {[key: string]: TemplateRef<any>};

    constructor() {
    }

    registerDdTemplates(
        togglerRef: CsDropDownTogglerTemplatesComponent,
        itemRef: CsDropDownItemTemplatesComponent
    ): Observable<{
        togglersHolder: {[key: string]: TemplateRef<any>},
        itemsHolder: {[key: string]: TemplateRef<any>}
    }> {

        // Register new Toggler-templates here :
        this.togglerTemplates = {
            BTN_TRANSPARENT: togglerRef.btnTransparent,
            BTN_PRIMARY: togglerRef.btnPrimary
        };

        // Register new Item-templates here :
        this.itemTemplates = {
            BASIC: itemRef.basicTemplate
        };

        return of({
            togglersHolder: this.togglerTemplates,
            itemsHolder: this.itemTemplates
        });
    }

    resetDdItemList(ddConfig: ICsDropDown, itemList: ICsDdItem[], group?: ICsDdGroupItem) {
        itemList.forEach(item => this.setItemConfig(ddConfig, item, group));
        group ? (group.items = itemList) : (ddConfig.ddMenuConfig.items = itemList);
        ddConfig.ddMenuConfig.totalItemsCount = this.getItemsBy(ddConfig, 'ALL').length;
        ddConfig.ddMenuConfig.selectedItemsCount = this.getItemsBy(ddConfig, 'SELECTED').length;
    }

    setItemConfig(ddConfig: ICsDropDown, item: ICsDdItem, group?: ICsDdGroupItem) {
        item.ddConfigId = ddConfig.id;
        item.ddGroupId = (group && group.id) || null;
        // item.filterId = item.id || null;
        item.itemTemplateType = item.itemTemplateType || (group && group.templateType) || ddConfig.ddMenuConfig.templateType;
        item.itemCustomTemplateRef = item.itemCustomTemplateRef || (group && group.customTemplateRef) || ddConfig.ddMenuConfig.customTemplateRef || null;
        item.isMultiChoiceItem = (group && group.isMultiChoice) || ddConfig.ddMenuConfig.isMultiChoice || null;
        item.indicatorIcon = (item.templateData['iconsList'] && item.templateData['iconsList'].find(icon => icon.isItemIndicator)) || null;
    }

    getItemsBy(ddConfig: ICsDropDown, getOnly?: 'SELECTED' | 'ENABLED' | 'ALL'): ICsDdItem[] {
        let allItemList: ICsDdItem[] = [];

        // Load all items to `allItemList` :
        if (ddConfig.ddMenuConfig.isGroupItem) {
            ddConfig.ddMenuConfig.groupItems.forEach(group => {
                allItemList.push(...group.items);
            });
        } else {
            allItemList = ddConfig.ddMenuConfig.items;
        }

        // Filter items by given constraint :
        if (getOnly === 'SELECTED') {
            allItemList = allItemList.filter(item => item.isSelected);
        } else if (getOnly === 'ENABLED') {
            allItemList = allItemList.filter(item => !item.isHide);
        }

        return allItemList;
    }
}
